import React from 'react';
import { EuroIcon } from 'lucide-react';

/**
 * Reassures Italian buyers that the price is charged directly in euro.
 */
export const LocalCurrencyNote = ({
  className = ''
}: {
  className?: string;
}) => <div className={`flex items-center justify-center gap-2 text-xs text-slate-400 ${className}`} data-id="element-372" data-mp="104929gjednhd">
    <EuroIcon size={14} className="shrink-0 text-sky-400" aria-hidden="true" data-id="element-373" data-mp="v6qq7ha32s55" />
    <p data-id="element-374" data-mp="q6mavukww3gi">
      <span className="font-semibold text-slate-200" data-id="element-375" data-mp="q7e7n8q8w78d">Paghi in euro</span>{' '}
      — nessuna conversione, nessun costo nascosto.
    </p>
  </div>;